import React from 'react';
import DOMPurify from 'dompurify';

import { useTranslation } from 'react-i18next';
import { showDialogAction, hideDialogAction } from 'components/redux-dialog/actions';
import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { Button } from 'components/button';
import { useDispatch, useSelector } from 'react-redux';
import { setLastConsentDate } from './terms-and-conditions-utils';

import { getUserId } from '../../utils/website';
import { termsAndConditionsSelector } from 'common/selectors/termsAndConditions';

const TERMS_AND_CONDITIONS = 'terms-and-conditions-popup';

export const openTermsAndConditions = (showCloseButton) =>
  showDialogAction(TERMS_AND_CONDITIONS, { showCloseButton: showCloseButton === true });

export const TermsAndConditionsPopup = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const termsAndConditionsData = useSelector(termsAndConditionsSelector);

  const onClose = () => {
    dispatch(hideDialogAction(TERMS_AND_CONDITIONS));
  };

  const onAcceptAll = () => {
    const userId = getUserId();
    setLastConsentDate(userId);
    onClose();
  };

  const { header, subHeader, content, language } = termsAndConditionsData || {};

  return (
    <DialogDecorated
      data-e2e="terms-and-conditions-popup"
      dialogName={TERMS_AND_CONDITIONS}
      className="terms-and-conditions"
    >
      <div className="terms-and-conditions__title-wrapper">
        <DialogTitle hideCloseButton>
          <h1 data-e2e="terms-and-conditions-popup-title" className="terms-and-conditions__title">
            {header}
          </h1>

          <h2 data-e2e="terms-and-conditions-popup-subtitle" className="terms-and-conditions__subtitle">
            {subHeader}
          </h2>
        </DialogTitle>
      </div>

      <DialogBody className="terms-and-conditions__body">
        <div
          data-e2e="terms-and-conditions-popup-content"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }) }}
        />
      </DialogBody>

      <DialogFooter className="terms-and-conditions__footer">
        <div className="d-flex terms-and-conditions__button-wrapper">
          <Button
            onClick={onAcceptAll}
            className="terms-and-conditions__accept-button terms-and-conditions__button"
            id="terms-and-conditions-accept"
          >
            {t('terms_and_conditions.accept_button', { lng: language })}
          </Button>
        </div>
      </DialogFooter>
    </DialogDecorated>
  );
};
